// Disable return types for import functions
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

// Directly import Home view for faster rendering of first page
import Home from '@/views/Home.vue';
import HomeMce from '@/views/HomeMce.vue';
import HomeUser from '@/views/HomeUser.vue';

/** See https://router.vuejs.org/fr/essentials/navigation.html for help */
export const routes = [
	// ============================================
	// ROUTES PUBLIQUES (NON AUTHENTIFIÉES)
	// ============================================
	{
		path: '/',
		name: 'home',
		component: Home,
		meta: {
			logged: false
		}
	},
	{
		path: '/:userType(employeur-particulier|assure)',
		name: 'homeUser',
		component: HomeUser,
		props: true,
		meta: {
			logged: false
		}
	},
	{
		path: '/:userType(employeur)',
		name: 'homeMce',
		component: HomeMce,
		props: true,
		meta: {
			logged: false
		}
	},

	// ============================================
	// AUTHENTIFICATION
	// ============================================
	{
		path: '/:userType(assure|employeur|employeur-particulier)/login',
		name: 'login',
		component: () => import(
			/* webpackChunkName: "auth" */
			'@/views/Connexion.vue'
			),
		props: true,
		meta: {
			logged: false
		}
	},
	{
		path: '/mot-de-passe/oublie',
		name: 'motDePasseOublie',
		component: () => import(
			/* webpackChunkName: "auth" */
			'@/views/MotDePasseOublie.vue'
			),
		meta: {
			logged: false
		}
	},
	{
		path: '/mot-de-passe/reinitialisation/:token',
		name: 'motDePasseReinitialisation',
		props: true,
		component: () => import(
			/* webpackChunkName: "auth" */
			'@/views/MotDePasseReinitialisation.vue'
			),
		meta: {
			logged: false
		}
	},

	// ============================================
	// INSCRIPTION
	// ============================================
	{
		path: '/inscription/:userType',
		name: 'inscription',
		props: true,
		component: () => import(
			/* webpackChunkName: "inscription" */
			'@/views/Inscription.vue'
			),
		meta: {
			logged: false
		}
	},
	{
		path: '/inscrivez-vous/assure',
		name: 'inscriptionAssure',
		component: () => import(
			/* webpackChunkName: "inscription" */
			'@/views/franceConnect/AssureInscriptionFC.vue'
			),
		meta: {
			logged: false
		}
	},
	{
		path: '/inscription/cgu',
		name: 'inscriptionCgu',
		component: () => import(
			/* webpackChunkName: "cgu" */
			'@/views/ValidateCgu.vue'
			),
		props: { update: false },
		meta: {
			logged: false
		}
	},
	{
		path: '/validation/:token',
		name: 'validationInscription',
		props: true,
		component: () => import(
			/* webpackChunkName: "inscription" */
			'@/views/ValidationInscription.vue'
			),
		meta: {
			logged: false
		}
	},

	// ============================================
	// CGU
	// ============================================
	{
		path: '/cgu',
		name: 'cgu',
		component: () => import(
			/* webpackChunkName: "cgu" */
			'@/views/Cgu.vue'
			),
		meta: {
			logged: false
		}
	},
	{
		path: '/update/cgu',
		name: 'updateCgu',
		component: () => import(
			/* webpackChunkName: "cgu" */
			'@/views/ValidateCgu.vue'
			),
		props: { update: true },
		meta: {
			logged: true
		}
	},

	// ============================================
	// GESTION EMAIL
	// ============================================
	{
		path: '/changement-email/:type',
		name: 'changementEmailNotice',
		props: true,
		component: () => import(
			/* webpackChunkName: "email" */
			'@/views/PageNotification.vue'
			),
		meta: {
			logged: false
		}
	},
	{
		path: '/validation/nouvel-email/:newEmail/:token',
		name: 'validationNewEmail',
		props: true,
		component: () => import(
			/* webpackChunkName: "email" */
			'@/views/ValidationNewEmail.vue'
			),
		meta: {
			logged: false
		}
	},

	// ============================================
	// ERREURS & NOTIFICATIONS
	// ============================================
	{
		path: '/erreur/reconciliation/:type',
		name: 'reconciliationKo',
		props: true,
		component: () => import(
			/* webpackChunkName: "notifications" */
			'@/views/PageNotification.vue'
			),
		meta: {
			logged: false
		}
	},

	// ============================================
	// ESPACE AUTHENTIFIÉ - DOSSIERS
	// ============================================
	{
		path: '/details-dossier/:dossierId',
		name: 'detailsDossier',
		props: true,
		component: () => import(
			/* webpackChunkName: "dossiers" */
			'@/views/DetailsDossier.vue'
			),
		meta: {
			logged: true,
			breadcrumb: [
				{ text: 'Questionnaire Risques Professionnel', to: { name: 'home' } },
				{ text: 'Détails du dossier' }
			]
		}
	},
	{
		path: '/questionnaire/:reponseId/:dossierId?',
		name: 'questionnaire',
		component: () => import(
			/* webpackChunkName: "dossiers" */
			'@/views/Questionnaire.vue'
			),
		props: true,
		meta: {
			logged: true,
			breadcrumb: [
				{ text: 'Questionnaire Risques Professionnel', to: { name: 'dossierEmployeur' } },
				{ text: 'Détails du dossier', to: 'detailsDossier' },
				{ text: 'Questionnaire' }
			]
		}
	},

	// ============================================
	// ESPACE AUTHENTIFIÉ - ONGLETS
	// ============================================
	{
		path: '',
		name: 'onglets',
		component: () => import(
			/* webpackChunkName: "onglets" */
			'@/views/onglets/Onglets.vue'
			),
		meta: {
			logged: true
		},
		children: [
			// EMPLOYEUR
			{
				path: '/employeur/dossiers',
				name: 'dossierEmployeur',
				component: () => import(
					/* webpackChunkName: "employeur" */
					'@/views/dossiers/DossierEmployeur.vue'
					),
				meta: {
					logged: true
				}
			},
			{
				path: '/employeur/mon-compte',
				name: 'compteEmployeur',
				component: () => import(
					/* webpackChunkName: "compte" */
					'@/views/onglets/Compte.vue'
					),
				meta: {
					logged: true
				}
			},
			// ASSURÉ
			{
				path: '/assure/dossiers',
				name: 'dossierAssure',
				component: () => import(
					/* webpackChunkName: "assure" */
					'@/views/dossiers/DossierAssure.vue'
					),
				meta: {
					logged: true
				}
			},
			{
				path: '/assure/mon-compte',
				name: 'compteAssure',
				component: () => import(
					/* webpackChunkName: "compte" */
					'@/views/onglets/Compte.vue'
					),
				meta: {
					logged: true
				}
			}
		]
	},

	// ============================================
	// PAGES SYSTÈME
	// ============================================
	{
		path: '/maintenance',
		name: 'maintenance',
		component: () => import(
			/* webpackChunkName: "system" */
			'@/views/Maintenance.vue'
			),
		meta: {
			logged: false
		}
	},
	{
		path: '*', // Everything that doesn't match a route
		name: 'notFound',
		component: () => import(
			/* webpackChunkName: "system" */
			'@/views/NotFound.vue'
			),
		meta: {
			logged: false
		}
	}
];
